<template>
  <div class="top-title-comp">
    <div class="title-icon">
      <i :class="icon" class="bx-md"></i>
      <div class="title">
        <h4>
          {{ title }}
        </h4>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top-title',

  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped></style>
